<template>
	<div class="memberLog layui-layout layui-layout-admin" style="background:#fff;">
		<div class="layui-header al_itm" style="background:#fff;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				等级评分
			</div>
		</div>
		<table class="layui-table align_center" id="orders" style="width:90%;margin:30px 5% 0;">
			<thead>
				<tr>
					<th class="align_center">序号</th>
					<th class="align_center">途径</th>
					<th class="align_center">积分</th>
					<th class="align_center">时间</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item,i) in datas" :key="i">
					<td>{{i+1}}</td>
					<td>{{item.title}}</td>
					<td>{{item.type==1?'':'-'}}{{item.score}}</td>
					<td>{{item.time}}</td>
				</tr>
				<tr v-if="datas.length == 0">
					<td style="padding: 5px 30px 0;text-align: center;line-height: 50px;" colspan="4">暂无数据</td>
				</tr>
			</tbody>
		</table>
		<div id="lypages" style="margin-left: 5%;"></div>
	</div>
</template>

<script>
	export default {
		name: 'memberLog',
		data() {
			return {
				count: 1,
				datas: [],
				pages: 1,
				limit: 10
			}
		},
		created() {

		},
		mounted() {
			let _this = this;
			_this.getData();
		},
		methods: {
			getData() {
				let _this = this;
				layui.use(['table', 'laypage'], () => {
					var table = layui.table;
					var laypage = layui.laypage;
					api.getFractionLog({
						token: _this.getCookie('token'),
						page: _this.pages,
						limit: _this.limit
					}).then((res) => {
						if(res.code == 1) {
							for(let i = 0; i < res.data.list.length; i++) {
								res.data.list[i].time = _this.getTimes2(res.data.list[i].createtime);
							}
							_this.datas = res.data.list;
							_this.count = res.data.count;
						} else {
							_this.datas = []
						}
						laypage.render({
							elem: 'lypages', //注意，这里的 lypages 是 ID，不用加 # 号
							theme: '#4876FF',
							curr: _this.pages,
							count: _this.count,
							limit: 10,
							jump: function(obj, first) {
								if(!first) {
									_this.pages = obj.curr;
									_this.getData();
								}
							}
						});
					})
				});
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.memberLog {
		font-family: SourceHanSansSC;
	}
</style>


// WEBPACK FOOTER //
// src/components/score.vue